'use client';
import { Select } from './select.js';
import { SelectOptgroup } from './select-optgroup.js';
import { SelectOption } from './select-option.js';

/**
 * Select component, used to display a native select.
 *
 * @example
 * <Select>
 *   <Select.Option value='1'>Option 1</Select.Option>
 *   <Select.Option value='2'>Option 2</Select.Option>
 * </Select>
 */
const SelectComponent = Object.assign(Select, {
    Option: SelectOption,
    Optgroup: SelectOptgroup,
});
SelectComponent.Option.displayName = 'Select.Option';
SelectComponent.Optgroup.displayName = 'Select.Optgroup';

export { SelectComponent as Select, SelectOptgroup, SelectOption };
